import { QuestionIcon, ThumbsDownIcon, ThumbsUpIcon } from 'react-line-awesome';
import { Button } from '@gtintel/platform-atoms';
export function FeedbackButtons() {
  const disabled = true;
  return <>
      <Button kind="secondary" disabled={disabled}>
        <ThumbsUpIcon />
      </Button>
      <Button kind="secondary" disabled={disabled}>
        <QuestionIcon />
      </Button>
      <Button kind="secondary" disabled={disabled}>
        <ThumbsDownIcon />
      </Button>
    </>;
}
export default FeedbackButtons;